import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "profile-fields" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    min_width: "min(68rem, 100%)",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => _cache[5] || (_cache[5] = [
      _createTextVNode("Edit User")
    ])),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[6] || (_cache[6] = _createElementVNode("label", null, "First Name", -1 /* HOISTED */)),
        _createVNode(_component_Input, {
          ref: "firstName",
          modelValue: $data.u_store.first_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.u_store.first_name) = $event)),
          "vread-from": "valid",
          "onUpdate:valid": $event => (($data.validity.first_name) = $event),
          maxlength: 50,
          required: ""
        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
        _cache[7] || (_cache[7] = _createElementVNode("label", null, "Last Name", -1 /* HOISTED */)),
        _createVNode(_component_Input, {
          modelValue: $data.u_store.last_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.u_store.last_name) = $event)),
          "vread-from": "valid",
          "onUpdate:valid": $event => (($data.validity.last_name) = $event),
          maxlength: 50,
          required: ""
        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:valid"]),
        _cache[8] || (_cache[8] = _createElementVNode("label", null, "Title", -1 /* HOISTED */)),
        _createVNode(_component_Input, {
          modelValue: $data.u_store.title,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.u_store.title) = $event)),
          maxlength: 100
        }, null, 8 /* PROPS */, ["modelValue"]),
        _cache[9] || (_cache[9] = _createElementVNode("label", null, "Bio", -1 /* HOISTED */)),
        _createVNode(_component_TextArea, {
          modelValue: $data.u_store.bio,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.u_store.bio) = $event)),
          class: "textarea",
          maxlength: 2048,
          rows: 6
        }, null, 8 /* PROPS */, ["modelValue"]),
        _cache[10] || (_cache[10] = _createElementVNode("label", null, "Offering", -1 /* HOISTED */)),
        _createVNode(_component_TextArea, {
          modelValue: $data.u_store.offering,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.u_store.offering) = $event)),
          class: "textarea",
          maxlength: 2048,
          rows: 6
        }, null, 8 /* PROPS */, ["modelValue"])
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        disabled: $options.saving,
        onClick: $options.close
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("Cancel")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_submit,
        loading: $options.saving,
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("Update")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "loading", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}